/**
 * Resolve a cover-image reference into a fully-qualified URL the browser can
 * actually fetch.
 *
 * 🔒 LIBRARY SEAL — DO NOT MODIFY (Feb 24 2026). See /app/memory/LIBRARY_SEAL.md.
 * Sealed until the user types "library upgrade".
 *
 * Handles three flavours that exist in the DB today:
 *   1. Absolute URL (https://...) — returned as-is
 *   2. /api/uploads/covers/...  — prefixed with BACKEND_URL
 *   3. /uploads/covers/...      — legacy; also prefixed with BACKEND_URL + "/api"
 *      so the request hits the backend ingress instead of resolving against the
 *      React SPA origin (which would return index.html).
 *
 * Falsy inputs return ''.
 */
export const resolveCoverUrl = (raw) => {
  if (!raw || typeof raw !== 'string') return '';
  const trimmed = raw.trim();
  if (!trimmed) return '';
  if (/^https?:\/\//i.test(trimmed) || trimmed.startsWith('data:')) {
    return trimmed;
  }
  const backend = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');
  if (trimmed.startsWith('/api/')) {
    return `${backend}${trimmed}`;
  }
  if (trimmed.startsWith('/uploads/')) {
    return `${backend}/api${trimmed}`;
  }
  // Unknown format — try prefixing with backend so relative paths at least
  // point at the right origin.
  return trimmed.startsWith('/') ? `${backend}${trimmed}` : trimmed;
};

export default resolveCoverUrl;
